var app = angular.module('leonardo');

var WPFormFile = function(NotificationService, AttachmentService, $timeout, $q, ConfigThemeService) {
  return {
    restrict: 'A',
    require: ['^form', 'ngModel'],
    scope: {
      wpFormFileType: '@',
      placeholder: '@',
      noManager: '=?',
      noLink: '=?',
      multiple: '=?',
      comment: '=?',
      modeUpload: '@',
      disabled: '=ngDisabled',
      required: '=ngRequired',
      onlyRead: '=?',
      inline: '=?',
      name: '@'
    },
    templateUrl: 'views/templates/form/form-file.html',
    link: function (scope, element, attrs, ctrls) {
      scope.formCtrl = ctrls[0];
      scope.ngModelCtrl = ctrls[1];

      scope.attachmentService = AttachmentService;

      scope.attachments = [];

      scope.isNull = function(value) {
        return isNull(value);
      };

      scope.initAttachments = function () {
        angular.forEach(scope.attachments, function(attachment) {
          if (!isNull(attachment.comment)) {
            attachment.comment_active = true;
          }
        });
      };

      scope.ngModelCtrl.$render = function () {
        scope.data = !isNull(scope.ngModelCtrl.$modelValue) ? scope.ngModelCtrl.$modelValue : [];
        if (angular.isArray(scope.data)) {
          scope.attachments = scope.data;
        }
        else {
          scope.attachments.push(scope.data);
        }
        scope.initAttachments();
      };

      scope.getFile = function(attachment) {
        if (isNull(attachment)) {
          return {};
        }
        return attachment.$file ? attachment.$file : attachment.file;
      };

      scope.changeComment = function(index) {
        if (!scope.attachments[index].comment_active) {
          scope.attachments[index].comment = '';
        }
      };

      scope.onAdd = function(attachment) {
        if (isNull(attachment)) {
          return;
        }
        attachment['progress'] = 0;
        attachment['finished'] = false;
        var file = {
          name: attachment.name,
          finished: false
        };
        if (attachment.promise) {
          attachment.promise.then(function(response) {
            attachment['finished'] = true;
            file.finished = true;
            file.file = response.data.file;
            file.type = response.data.type;
            file.id = response.data.id;
          }, function (error) {
            NotificationService.error(error);
          }, function(evt) {
            attachment['progress'] = parseInt(evt.loaded / evt.total);
          });
        }
        else {
          attachment['finished'] = true;
        }
        $q.when(attachment.promise).then(function() {
          scope.attachments.push(attachment);
          scope.ngModelCtrl.$setViewValue(scope.attachments.length > 0 ? scope.attachments : null);
        });
      };

      scope.cancel = function(attachment, $index) {
        if (scope.disabled) {
          return;
        }
        if (attachment.promise) {
          attachment.promise.abort();
        }
        $timeout(function () {
          scope.remove($index);
        }, 0);
      };

      scope.remove = function($index) {
        if (scope.disabled) {
          return;
        }
        $timeout(function () {
          scope.attachments.splice($index, 1);
          scope.ngModelCtrl.$setViewValue(scope.attachments.length > 0 ? scope.attachments : null);
        }, 0);
      };

      scope.getOptions = function() {
        return {color: ConfigThemeService.config.theme_config.successColor};
      };

      scope.ngModelCtrl.$validators.required = function(modelValue) {
        if (!scope.required) {
          return true;
        }
        if(modelValue) {
          if (angular.isArray(modelValue)) {
            return (modelValue.length > 0);
          }
          else {
            return !isNull(modelValue);
          }
        }
      };

    }
  };
};

app.directive('wpFormFile', ['NotificationService', 'AttachmentService', '$timeout', '$q', 'ConfigThemeService', WPFormFile]);
